(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-logoconsota></app-logoconsota>\n\n<router-outlet></router-outlet>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/menuprincipal/menuprincipal.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/menuprincipal/menuprincipal.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/logoconsota/logoconsota.component.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/logoconsota/logoconsota.component.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<header class=\"header\">\n    <figure class=\"logo\">\n        <!--\n            <img src=\"assets/images/logo_comfamiliar.png\" alt=\"Logo confamiliar\" />\n        -->\n        <a href=\"https://consota.comfamiliar.com\">\n            <img src=\"assets/images/logoconsotapata.png\" alt=\"Logo confamiliar\" width=\"260px\" height=\"60px\" />\n        </a>\n        <!--\n    <img src=\"assets/images/logo-consota-122x52.png\" alt=\"Logo confamiliar\" width=\"142px\" height=\"60px\" />\n-->\n\n    </figure>\n\n\n</header>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/$$_lazy_route_resource lazy recursive":
/*!**********************************************************!*\
  !*** ./src/$$_lazy_route_resource lazy namespace object ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js");



const routes = [
    {
        path: '',
        loadChildren: () => __webpack_require__.e(/*! import() | alojamiento-alojamiento-module */ "alojamiento-alojamiento-module").then(__webpack_require__.bind(null, /*! ./alojamiento/alojamiento.module */ "./src/app/alojamiento/alojamiento.module.ts")).then(m => m.AlojamientoModule),
        data: {
            preload: true
        }
    },
    {
        path: 'alojamiento',
        loadChildren: () => __webpack_require__.e(/*! import() | alojamiento-alojamiento-module */ "alojamiento-alojamiento-module").then(__webpack_require__.bind(null, /*! ./alojamiento/alojamiento.module */ "./src/app/alojamiento/alojamiento.module.ts")).then(m => m.AlojamientoModule),
        data: {
            preload: true
        }
    },
    {
        path: 'ordenservicio',
        loadChildren: () => __webpack_require__.e(/*! import() | ordenservicio-ordenservicio-module */ "ordenservicio-ordenservicio-module").then(__webpack_require__.bind(null, /*! ./ordenservicio/ordenservicio.module */ "./src/app/ordenservicio/ordenservicio.module.ts")).then(m => m.OrdenservicioModule),
        data: {
            preload: true
        }
    }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes, { useHash: true })],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js");



// import 'rxjs/add/operator/distinctUntilChanged';
// import 'rxjs/add/operator/filter';
// declare var gtag;
let AppComponent = class AppComponent {
    constructor(router, activatedRoute) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.queryParamsStatus = '';
        this.activatedRoute.queryParams.subscribe(params => {
        });
        /*
            const navEndEvents$ = this.router.events.pipe(
              filter(event => event instanceof NavigationEnd)
            );
        
            navEndEvents$.subscribe((event: NavigationEnd) => {
              gtag('config', 'UA-150930480-1', {
                page_path: event.urlAfterRedirects
              });
            });
            */
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"], _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"]])
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: SentryErrorHandler, AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SentryErrorHandler", function() { return SentryErrorHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/__ivy_ngcc__/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/__ivy_ngcc__/fesm2015/http.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/__ivy_ngcc__/fesm2015/ng-bootstrap.js");
/* harmony import */ var _sweetalert2_ngx_sweetalert2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @sweetalert2/ngx-sweetalert2 */ "./node_modules/@sweetalert2/ngx-sweetalert2/__ivy_ngcc__/fesm2015/sweetalert2-ngx-sweetalert2.js");
/* harmony import */ var _shared_logoconsota_logoconsota_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./shared/logoconsota/logoconsota.component */ "./src/app/shared/logoconsota/logoconsota.component.ts");
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @sentry/browser */ "./node_modules/@sentry/browser/esm/index.js");
/* harmony import */ var _menuprincipal_menuprincipal_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./menuprincipal/menuprincipal.component */ "./src/app/menuprincipal/menuprincipal.component.ts");
/* harmony import */ var _core_services_auth_interceptor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./core/services/auth.interceptor */ "./src/app/core/services/auth.interceptor.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/__ivy_ngcc__/fesm2015/animations.js");








// Componentes





// environment.production
_sentry_browser__WEBPACK_IMPORTED_MODULE_9__["init"]({
    dsn: 'https://cb9591aaf8644e6c99dadb0da6cfddfd@sentry.io/1805230'
});
let SentryErrorHandler = class SentryErrorHandler {
    constructor() { }
    handleError(error) {
        const eventId = _sentry_browser__WEBPACK_IMPORTED_MODULE_9__["captureException"](error.originalError || error);
        _sentry_browser__WEBPACK_IMPORTED_MODULE_9__["showReportDialog"]({ eventId });
    }
};
SentryErrorHandler = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], SentryErrorHandler);

let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"],
            _shared_logoconsota_logoconsota_component__WEBPACK_IMPORTED_MODULE_8__["LogoconsotaComponent"],
            _menuprincipal_menuprincipal_component__WEBPACK_IMPORTED_MODULE_10__["MenuprincipalComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_3__["AppRoutingModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpClientModule"],
            _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModule"],
            _sweetalert2_ngx_sweetalert2__WEBPACK_IMPORTED_MODULE_7__["SweetAlert2Module"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_12__["BrowserAnimationsModule"]
        ],
        providers: [
            {
                provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HTTP_INTERCEPTORS"],
                useClass: _core_services_auth_interceptor__WEBPACK_IMPORTED_MODULE_11__["AuthInterceptor"],
                multi: true
            }
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/core/config/config.ts":
/*!***************************************!*\
  !*** ./src/app/core/config/config.ts ***!
  \***************************************/
/*! exports provided: URL_SERVICIOS, URL_SERVICIOS_CONSOTA, URL_SIGEC, HTTPOPTIONS, ERROR_CONSULTANDOSERVICIO, COLOR_INFO, COLOR_SUCCESS, COLOR_WARNING, COLOR_DANGER, COLOR_ROSE, COLOR_PRIMARY */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "URL_SERVICIOS", function() { return URL_SERVICIOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "URL_SERVICIOS_CONSOTA", function() { return URL_SERVICIOS_CONSOTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "URL_SIGEC", function() { return URL_SIGEC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HTTPOPTIONS", function() { return HTTPOPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_CONSULTANDOSERVICIO", function() { return ERROR_CONSULTANDOSERVICIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLOR_INFO", function() { return COLOR_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLOR_SUCCESS", function() { return COLOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLOR_WARNING", function() { return COLOR_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLOR_DANGER", function() { return COLOR_DANGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLOR_ROSE", function() { return COLOR_ROSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLOR_PRIMARY", function() { return COLOR_PRIMARY; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/__ivy_ngcc__/fesm2015/http.js");


const URL_SERVICIOS = 'https://wssigec.comfamiliar.com/webresources/alojamiento/';
// export const URL_SERVICIOS = 'http://localhost:8080/rolcliente/webresources/alojamiento/';
// export const URL_SERVICIOS = 'https://wssigec.comfamiliar.com/webresources/alojamiento/';
const URL_SERVICIOS_CONSOTA = 'https://wssigec.comfamiliar.com/webresources/consota/';
const URL_SIGEC = 'https://wssigec.comfamiliar.com/webresources/sigec/';
const HTTPOPTIONS = {
    headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({
        // 'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8',
        'Content-Type': 'application/json',
        'Authorization': 'my-new-auth-token'
    })
};
const ERROR_CONSULTANDOSERVICIO = 'Error consultando el servicio';
const COLOR_INFO = 'info';
const COLOR_SUCCESS = 'success';
const COLOR_WARNING = 'warning';
const COLOR_DANGER = 'danger';
const COLOR_ROSE = 'rose';
const COLOR_PRIMARY = 'primary';


/***/ }),

/***/ "./src/app/core/services/auth.interceptor.ts":
/*!***************************************************!*\
  !*** ./src/app/core/services/auth.interceptor.ts ***!
  \***************************************************/
/*! exports provided: AuthInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthInterceptor", function() { return AuthInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js");


let AuthInterceptor = class AuthInterceptor {
    constructor() {
    }
    intercept(request, next) {
        request = this.addToken(request);
        return next.handle(request);
    }
    addToken(request) {
        const token = '123';
        if (true) {
            request = request.clone({
                setHeaders: {
                    token
                }
            });
            return request;
        }
        return request;
    }
};
AuthInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AuthInterceptor);



/***/ }),

/***/ "./src/app/core/services/encrdecr.service.ts":
/*!***************************************************!*\
  !*** ./src/app/core/services/encrdecr.service.ts ***!
  \***************************************************/
/*! exports provided: EncrdecrService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EncrdecrService", function() { return EncrdecrService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! crypto-js */ "./node_modules/crypto-js/index.js");
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_2__);



let EncrdecrService = class EncrdecrService {
    constructor() { }
    //The set method is use for encrypt the value.
    set(keys, value) {
        var key = crypto_js__WEBPACK_IMPORTED_MODULE_2__["enc"].Utf8.parse(keys);
        var iv = crypto_js__WEBPACK_IMPORTED_MODULE_2__["enc"].Utf8.parse(keys);
        var encrypted = crypto_js__WEBPACK_IMPORTED_MODULE_2__["AES"].encrypt(crypto_js__WEBPACK_IMPORTED_MODULE_2__["enc"].Utf8.parse(value.toString()), key, {
            keySize: 128 / 8,
            iv: iv,
            mode: crypto_js__WEBPACK_IMPORTED_MODULE_2__["mode"].CBC,
            padding: crypto_js__WEBPACK_IMPORTED_MODULE_2__["pad"].Pkcs7
        });
        return encrypted.toString();
    }
    //The get method is use for decrypt the value.
    get(keys, value) {
        var key = crypto_js__WEBPACK_IMPORTED_MODULE_2__["enc"].Utf8.parse(keys);
        var iv = crypto_js__WEBPACK_IMPORTED_MODULE_2__["enc"].Utf8.parse(keys);
        var decrypted = crypto_js__WEBPACK_IMPORTED_MODULE_2__["AES"].decrypt(value, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: crypto_js__WEBPACK_IMPORTED_MODULE_2__["mode"].CBC,
            padding: crypto_js__WEBPACK_IMPORTED_MODULE_2__["pad"].Pkcs7
        });
        return decrypted.toString(crypto_js__WEBPACK_IMPORTED_MODULE_2__["enc"].Utf8);
    }
    generateHash(transaccionConvenioId) {
        const convenioId = 8178;
        const claveHttps = 'COMFAMI2018';
        const texto = [convenioId, transaccionConvenioId || ''].join('-');
        const hash = crypto_js__WEBPACK_IMPORTED_MODULE_2__["HmacSHA256"](texto, claveHttps);
        console.log('Hash: ', hash);
        return crypto_js__WEBPACK_IMPORTED_MODULE_2__["enc"].Base64.stringify(hash);
    }
};
EncrdecrService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], EncrdecrService);



/***/ }),

/***/ "./src/app/core/services/sigec.service.ts":
/*!************************************************!*\
  !*** ./src/app/core/services/sigec.service.ts ***!
  \************************************************/
/*! exports provided: SigecService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SigecService", function() { return SigecService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/__ivy_ngcc__/fesm2015/http.js");
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../config/config */ "./src/app/core/config/config.ts");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @sentry/browser */ "./node_modules/@sentry/browser/esm/index.js");

/*import { BehaviorSubject, observable } from 'rxjs/Rx';*/





let SigecService = class SigecService {
    constructor(http) {
        this.http = http;
    }
    executeFetch(url, origen) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            try {
                const response = yield fetch(url);
                switch (response.status) {
                    case 404:
                        const error404 = new Error('Error 404 ejecutando url: ' + url) + ' desde ' + origen;
                        _sentry_browser__WEBPACK_IMPORTED_MODULE_5__["captureException"](error404);
                        sweetalert2__WEBPACK_IMPORTED_MODULE_4___default.a.fire('Error consultando datos', 'Se ha notificado al administrador del sistema. Por favor intente de nuevo mas tarde', 'error');
                        return undefined;
                    case 200:
                        const data = yield response.json();
                        return data;
                    default:
                        const error = new Error('Error ' + response.status + ' ejecutando url: ' + url) + ' desde ' + origen;
                        _sentry_browser__WEBPACK_IMPORTED_MODULE_5__["captureException"](error);
                        sweetalert2__WEBPACK_IMPORTED_MODULE_4___default.a.fire('Error consultando datos', 'Se ha notificado al administrador del sistema. Por favor intente de nuevo mas tarde', 'error');
                        return undefined;
                }
            }
            catch (error) {
                _sentry_browser__WEBPACK_IMPORTED_MODULE_5__["captureException"](error);
                sweetalert2__WEBPACK_IMPORTED_MODULE_4___default.a.fire('Error consultando datos', 'Se ha notificado al administrador del sistema. Por favor intente de nuevo mas tarde', 'error');
            }
        });
    }
    consultarProcesoAutenticacion(cunumid, pvcod, clave) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const url = _config_config__WEBPACK_IMPORTED_MODULE_3__["URL_SIGEC"] + 'consultarProcesoAutenticacion/' + cunumid + '/' + pvcod + '/' + clave;
            const data = yield this.executeFetch(url, 'consultarProcesoAutenticacion');
            return data;
        });
    }
    consultarProcesoVentaCodigo(pvcod) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const url = _config_config__WEBPACK_IMPORTED_MODULE_3__["URL_SIGEC"] + 'consultarProcesoVentaCodigo/' + pvcod;
            const data = yield this.executeFetch(url, 'consultarProcesoVentaCodigo');
            return data;
        });
    }
    validatebankpayment(transaccionconvenioid, hash) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const url = _config_config__WEBPACK_IMPORTED_MODULE_3__["URL_SIGEC"] + 'validatebankpayment';
            let datos;
            datos = JSON.stringify({
                transaccionconvenioid,
                hash
            });
            const response = yield fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    // 'Content-Type': 'application/x-www-form-urlencoded'
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: datos
            });
            const data = yield response.json();
            return data;
            /*
              const url = URL_SIGEC + 'validatebankpayment/'
                          + transaccionconvenioid + '/' +
                          hash;
              debugger;
              const response = await fetch(url);
              const data = await response.json();
          
              console.log('Datos:, ', data);
              return data;
              */
        });
    }
};
SigecService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
SigecService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"]])
], SigecService);



/***/ }),

/***/ "./src/app/menuprincipal/menuprincipal.component.css":
/*!***********************************************************!*\
  !*** ./src/app/menuprincipal/menuprincipal.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("body {\n    overflow: hidden;\n    background: #E6E6FA;\n    background: linear-gradient(to right, #AFEEEE, #E6E6FA)\n}\n\n.menu-toggler {\n    position: absolute;\n    display: block;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    margin: auto;\n    width: 40px;\n    height: 40px;\n    z-index: 2;\n    opacity: 0;\n    cursor: pointer;\n}\n\n.menu-toggler:hover+label,\n.menu-toggler:hover+label:before,\n.menu-toggler:hover+label:after,\n{\n    background: white;\n}\n\n.menu-toggler:checked+label {\n    background: transparent;\n}\n\n.menu-toggler:checked+label:before,\n.menu-toggler:checked+label:after,\n{\n    top: 0;\n    width: 40px;\n    transform-origin: 50% 50%;\n}\n\n.menu-toggler:checked+label:before {\n    transform: rotate(45deg) translateY(-15px) translateX(-15px);\n}\n\n.menu-toggler:checked+label:after {\n    transform: rotate(-45deg);\n}\n\n.menu-toggler:checked~ul .menu-item {\n    opacity: 1;\n}\n\n.menu-toggler:checked~ul .menu-item:nth-child(1) {\n    transform: rotate(0deg) translate(-110px);\n}\n\n.menu-toggler:checked~ul .menu-item:nth-child(2) {\n    transform: rotate(60deg) translateX(-110px);\n}\n\n.menu-toggler:checked~ul .menu-item:nth-child(3) {\n    transform: rotate(120deg) translateX(-110px);\n}\n\n.menu-toggler:checked~ul .menu-item:nth-child(4) {\n    transform: rotate(180deg) translateX(-110px);\n}\n\n.menu-toggler:checked~ul .menu-item:nth-child(5) {\n    transform: rotate(240deg) translateX(-110px);\n}\n\n.menu-toggler:checked~ul .menu-item:nth-child(6) {\n    transform: rotate(300deg) translateX(-110px);\n}\n\n.menu-toggler:checked~ul .menu-item a {\n    pointer-events: auto;\n}\n\n.menu-toggler+label {\n    width: 40px;\n    height: 5px;\n    display: block;\n    z-index: 1;\n    border-radius: 2.5px;\n    background: rgba(230, 239, 250, 0.9);\n    transition: transform 0.5s top 0.5s;\n    position: absolute;\n    display: block;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n.menu-toggler+label:before,\n.menu-toggler+label:after {\n    width: 40px;\n    height: 5px;\n    display: block;\n    z-index: 1;\n    border-radius: 2.5px;\n    background: rgba(255, 255, 255, 0.7);\n    transition: transform 0.5s top 0.5s;\n    content: \"\";\n    position: absolute;\n    display: block;\n    left: 0;\n}\n\n.menu-toggler+label:before {\n    top: 10px;\n}\n\n.menu-toggler+label:after {\n    top: -10px;\n}\n\n.menu-item:nth-child(1) a {\n    transform: rotate(0deg);\n}\n\n.menu-item:nth-child(2) a {\n    transform: rotate(-60deg);\n}\n\n.menu-item:nth-child(3) a {\n    transform: rotate(-120deg);\n}\n\n.menu-item:nth-child(4) a {\n    transform: rotate(-180deg);\n}\n\n.menu-item:nth-child(5) a {\n    transform: rotate(-240deg);\n}\n\n.menu-item:nth-child(6) a {\n    transform: rotate(-300deg);\n}\n\n.menu-item {\n    position: absolute;\n    display: block;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 80px;\n    height: 80px;\n    opacity: 0;\n    transition: 0.5s;\n}\n\n.menu-item a {\n    display: block;\n    width: inherit;\n    height: inherit;\n    line-height: 80px;\n    color: rgba(255, 255, 255, 0.7);\n    background: rgba(1, 69, 150, 1);\n    border-radius: 50%;\n    text-align: center;\n    text-decoration: none;\n    font-size: 40px;\n    pointer-events: none;\n    transition: 0.2s;\n}\n\n.menu-item a:hover {\n    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);\n    color: #e7650c;\n    background: rgba(255, 255, 255, 0.3);\n    font-size: 44.44px\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/menuprincipal/menuprincipal.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/menuprincipal/menuprincipal.component.ts ***!
  \**********************************************************/
/*! exports provided: MenuprincipalComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MenuprincipalComponent", function() { return MenuprincipalComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js");
/* harmony import */ var _core_services_encrdecr_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/services/encrdecr.service */ "./src/app/core/services/encrdecr.service.ts");
/* harmony import */ var _core_services_sigec_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @core/services/sigec.service */ "./src/app/core/services/sigec.service.ts");





let MenuprincipalComponent = class MenuprincipalComponent {
    constructor(activatedRoute, router, encrdecr, sigecService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.encrdecr = encrdecr;
        this.sigecService = sigecService;
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params) {
                if (params.transaccionConvenioId) {
                    this.transaccionConvenioId = params.transaccionConvenioId;
                }
                else {
                    this.router.navigate(['/alojamiento/registrarreserva']);
                }
            }
        });
    }
    ngOnInit() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.proccessTransaction();
        });
    }
    proccessTransaction() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            try {
                if (this.transaccionConvenioId) {
                    const hash = this.encrdecr.generateHash(this.transaccionConvenioId);
                    const data = yield this.sigecService.validatebankpayment(this.transaccionConvenioId, hash);
                    switch (data.code) {
                        case '200':
                            alert(data.msg);
                            break;
                        default:
                            alert('La transaccion no es válida');
                    }
                }
            }
            catch (error) {
                alert('Se ha generado un error' + error);
            }
        });
    }
};
MenuprincipalComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _core_services_encrdecr_service__WEBPACK_IMPORTED_MODULE_3__["EncrdecrService"] },
    { type: _core_services_sigec_service__WEBPACK_IMPORTED_MODULE_4__["SigecService"] }
];
MenuprincipalComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-menuprincipal',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./menuprincipal.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/menuprincipal/menuprincipal.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./menuprincipal.component.css */ "./src/app/menuprincipal/menuprincipal.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"],
        _core_services_encrdecr_service__WEBPACK_IMPORTED_MODULE_3__["EncrdecrService"],
        _core_services_sigec_service__WEBPACK_IMPORTED_MODULE_4__["SigecService"]])
], MenuprincipalComponent);



/***/ }),

/***/ "./src/app/shared/logoconsota/logoconsota.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/shared/logoconsota/logoconsota.component.ts ***!
  \*************************************************************/
/*! exports provided: LogoconsotaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogoconsotaComponent", function() { return LogoconsotaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js");


let LogoconsotaComponent = class LogoconsotaComponent {
    constructor() { }
    ngOnInit() {
    }
};
LogoconsotaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-logoconsota',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./logoconsota.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/logoconsota/logoconsota.component.html")).default
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], LogoconsotaComponent);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/__ivy_ngcc__/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /home/andres/NetBeansProjects/JAVA/proyectosangular2023/sigec/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map